const ALLOWED_TAGS = new Set(["B", "I", "U", "STRONG", "EM", "P", "BR"]);

export function isHtmlComment(text) {
  return /<[a-z][\s\S]*>/i.test(text || "");
}

export function isEmptyComment(html) {
  if (!html) return true;
  const text = html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();
  return !text;
}

export function sanitizeCommentHtml(dirty) {
  if (!dirty) return "";
  if (!isHtmlComment(dirty)) return dirty;

  const parser = new DOMParser();
  const doc = parser.parseFromString(dirty, "text/html");

  const clean = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType !== Node.ELEMENT_NODE) return;

      if (!ALLOWED_TAGS.has(child.tagName)) {
        while (child.firstChild) {
          child.parentNode.insertBefore(child.firstChild, child);
        }
        child.remove();
        return;
      }

      [...child.attributes].forEach((attr) => child.removeAttribute(attr.name));
      clean(child);
    });
  };

  clean(doc.body);
  return doc.body.innerHTML.trim();
}

export function getProfileDisplayName(profile) {
  if (!profile) return "";
  const first =
    profile.first_name || profile.FirstName || profile.firstName || "";
  const last = profile.last_name || profile.LastName || profile.lastName || "";
  return [first, last].filter(Boolean).join(" ");
}

export function getCommentAuthorName(comment) {
  return [comment?.FirstName, comment?.LastName].filter(Boolean).join(" ");
}
